'use client';

import { useState } from 'react';

interface ConsultLabelInputRowProps {
  label: string;
  placeholder: string;
  maxLength: number;
  value: string;
  essential: boolean;
  type?: 'text' | 'tel' | 'email';
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ConsultLabelInputRow = ({ label, placeholder, maxLength, value, essential, type = 'text', onChange }: ConsultLabelInputRowProps) => {
  return (
    <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-[0.5rem]">
      <label htmlFor="name" className="text-[0.938rem] md:text-[1.125rem] leading-[1.375rem] font-medium">
        {label}
        {essential && <span className="ml-[0.12rem] text-[0.938rem] md:text-[1rem] leading-[1.125rem] font-medium text-red-500">*</span>}
      </label>
      <input
        id="name"
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        maxLength={maxLength}
        className="w-full md:w-[21.4rem] px-[1rem] py-[15px] md:px-[1rem] border border-gray-200 rounded-lg text-[1rem] leading-[1.5rem] font-medium placeholder:text-gray-400"
      />
    </div>
  );
};

export default ConsultLabelInputRow;
